import Logo from "../../assets/quickstaff_logo_white.svg";
import FooterTab from "../FooterTab";
import Twitter from "../../assets/icons/twitter.svg";
import Instagram from "../../assets/icons/instagram.svg";
import Copyright from "../../assets/copyright.svg";

const Footer = () => {
  const InformationSub = [
    { subtitle: "About", link: "#about" },
    { subtitle: "Pricing", link: "#prices" },
    { subtitle: "Services", link: "#services" },
  ];
  const AddressSub = [{ subtitle: "1 Akinwunmi St, Yaba 100242, Lagos" }];
  return (
    <footer className="w-full sys_bg_black text-white py-16 px-6">
      <div className="grid grid-cols-1 lg:grid-cols-4 justify-items-start lg:justify-items-center">
        <img src={Logo} alt="" />
        <FooterTab title="Information" subtitles={InformationSub} />
        <FooterTab title="Address" subtitles={AddressSub} />
        <div>
          <FooterTab title="Socials" />
          <div className="flex items-center">
            <a href="https://instagram.com/hirequickstaff" target="_blank" rel="noreferrer">
              <img className="mr-6" src={Instagram} alt="" />
            </a>
            <a href="https://twitter.com/hirequickstaff" target="_blank" rel="noreferrer">
              <img src={Twitter} alt="" />
            </a>
          </div>
        </div>
      </div>
      <div className="mt-8 flex justify-start lg:justify-center">
        <img className="w-72" src={Copyright} alt="" />
      </div>
    </footer>
  );
};

export default Footer;
